import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { TiptapDirective } from './tiptap.directive'
import { CommonModule } from '@angular/common'
import { TiptapToolbarComponent } from './tiptap-toolbar/tiptap-toolbar.component'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { NzToolTipModule } from 'ng-zorro-antd/tooltip'

@NgModule({
  declarations: [
    TiptapDirective,
    TiptapToolbarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NzIconModule,
    NzToolTipModule
  ],
  exports: [
    TiptapDirective,
    TiptapToolbarComponent
  ]
})
export class TiptapModule { }
